import API from "./api";

/* =========================================================
   ACHIEVEMENT API
   Wraps every /api/achievements endpoint.
========================================================= */

/* -------- Employee -------- */

// Submit a completed-work entry against a target
// data: { target_id, completed_quantity, achievement_date, remarks }
export const submitAchievement = (data) => API.post("/achievements", data);

// Get achievements submitted by the logged-in employee
export const getMyAchievements = () => API.get("/achievements/me");

/* -------- Admin -------- */

// filters: { search, employee_id, status, date_from, date_to, sort_by, sort_dir, page, limit }
export const getAllAchievements = (filters = {}) =>
  API.get("/achievements", { params: filters });

// Export achievements as CSV (same filters, minus pagination)
export const exportAchievements = (filters = {}) =>
  API.get("/achievements/export", { params: filters, responseType: "blob" });

// data: { completed_quantity, achievement_date, remarks, status }
export const updateAchievement = (id, data) => API.put(`/achievements/${id}`, data);

export const deleteAchievement = (id) => API.delete(`/achievements/${id}`);

export default {
  submitAchievement,
  getMyAchievements,
  getAllAchievements,
  exportAchievements,
  updateAchievement,
  deleteAchievement,
};
